import { API_V2 } from "@/config/api";
import { Donors, DonorStatus } from "../types/models/Donors";
import { apiRequest } from "@gogive/services";

export const routes = {
  donors: `${API_V2}/donors`,
  export: `${API_V2}/donors/report`,
  topDonors: `${API_V2}/donors/top`,
  maxDonation: `${API_V2}/donors/stats/max-donation`,
  countByStatus: `${API_V2}/donors/count-by-status`,
  get: (donorId: number | string) => `${API_V2}/donors/${donorId}`,
  recurringPlans: (donorId: number | string) =>
    `${API_V2}/donors/${donorId}/recurring-plans`,
  roundupPlans: (donorId: number | string) =>
    `${API_V2}/donors/${donorId}/roundup-plans`,
  stats: (donorId: number | string) => `${API_V2}/donors/${donorId}/stats`,
};

export interface TopDonor {
  id: number;
  firstName: string;
  lastName: string;
  donationCount: number;
  /** Net to your organisation, cents (same convention as other stats). */
  totalAmount: number;
  /** Latest paid donation row `created_at` for this account (ISO). */
  lastDonationAt: string | null;
}

export interface TopDonorsResponse {
  result: TopDonor[];
}

export interface DonorStatsResponse {
  donorSince: string;
  lastDonationAt: string | null;
  lastDonationDaysAgo: number | null;
  lifetimeNetAmount: number;
  donationCount: number;
  engagementPercentile: number;
  donorStatus: DonorStatus;
}

export type DonorsListSortBy = "createdAt" | "donatedGross" | "donationCount";

export interface DonorsRequest {
  page: number;
  limit: number;
  sortBy: DonorsListSortBy;
  sortDirection: "ASC" | "DESC";
  keyword?: string;
  donorStatus?: DonorStatus;
  startDate?: string;
  endDate?: string;
  minAmount?: number;
  maxAmount?: number;
  donorType?: "regular" | "one-off";
}

export interface MaxDonationResponse {
  maxDonation: number;
}

export type DonorCountByStatusMap = Record<DonorStatus, number>;

export interface DonorCountByStatusResponse {
  total: number;
  byStatus: DonorCountByStatusMap;
}

export interface DonorsResponse {
  result: Donors[];
  total: number;
  page: number;
  pages: number;
}

export const downloadDonors = () =>
  apiRequest<any>(routes.export, {
    method: "GET",
  });
